import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFindings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M15.481 2.762a.556.556 0 0 0-.962 0l-1.444 2.5a.556.556 0 0 0 .482.834h2.886a.556.556 0 0 0 .482-.834zm-11 10.515a.556.556 0 0 0-.962 0l-1.444 2.5a.556.556 0 0 0 .481.834h2.888a.556.556 0 0 0 .48-.834zm7.586.686a2.067 2.067 0 1 0 0-4.134 2.067 2.067 0 0 0 0 4.134m0 2a4.067 4.067 0 1 0 0-8.134 4.067 4.067 0 0 0 0 8.134"
      clipRule="evenodd"
    />
    <path d="M13.786 14.774a1 1 0 0 1 1.415-1.414l2.804 2.804a1 1 0 0 1-1.414 1.414zM2 4.354c0-.748.607-1.355 1.355-1.355h6.29a1.355 1.355 0 0 1 0 2.71h-6.29A1.355 1.355 0 0 1 2 4.354m0 5c0-.748.607-1.355 1.355-1.355h2.29a1.355 1.355 0 0 1 0 2.71h-2.29A1.355 1.355 0 0 1 2 9.354" />
  </svg>
);
export default SvgFindings;
